module.exports = __webpack_public_path__ + "img/bzlx4.2f794387.png";